// Custom Oy File

(function () {
  var log = function () {
    if (!window.console) return;
    try { console.log.apply(console, arguments); } catch (e) {}
  };
  var warn = function () {
    if (!window.console) return;
    try { console.warn.apply(console, arguments); } catch (e) {}
  };

  var getFileNameFromUrl = function (url) {
    if (!url) return '';
    try {
      var clean = url.split('?')[0];
      return clean.split('/').pop() || '';
    } catch (e) {
      return '';
    }
  };

  var canonicalizeFileName = function (fileName) {
    if (!fileName) return '';
    var name = String(fileName);
    try { name = decodeURIComponent(name); } catch (e) {}
    return name.trim().toLowerCase();
  };

  var normalizeFileName = function (fileName) {
    if (!fileName) return '';
    return fileName.replace(/_(?:\d+x\d+|\d+x|x\d+)(?=\.[^.]+$)/, '');
  };

  var isInside = function (el, selector) {
    return !!(el && el.closest && selector && el.closest(selector));
  };

  var safeJsonParse = function (text, fallback) {
    try {
      return JSON.parse(text || '');
    } catch (e) {
      return fallback;
    }
  };

  var normalizeLocale = function (locale) {
    var l = (locale || '').toString().trim().toLowerCase();
    if (!l) return { full: 'en', base: 'en' };
    var base = l.split('-')[0] || l;
    return { full: l, base: base };
  };

  var normalizeAltForToken = function (alt) {
    var s = (alt || '').toString();
    s = s.replace(/[\u200B-\u200D\uFEFF]/g, ''); // zero-width chars
    s = s.replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-'); // hyphen/dash variants
    return s;
  };

  var debugTailCharCodes = function (str, count) {
    var s = (str || '').toString();
    var start = Math.max(0, s.length - (count || 12));
    var tail = s.slice(start);
    var codes = [];
    for (var i = 0; i < tail.length; i++) codes.push(tail.charCodeAt(i));
    return { tail: tail, codes: codes };
  };

  var initForSection = function (sectionEl) {
    var enabled = sectionEl.getAttribute('data-enabled') === 'true';
    if (!enabled) return;

    var debugSetting = sectionEl.getAttribute('data-debug') === 'true';
    var debug = debugSetting;

    var gallerySelector = sectionEl.getAttribute('data-gallery-selector') || '[data-product-single-media-group]';
    var slideSelector = sectionEl.getAttribute('data-slide-selector') || '[data-product-single-media-wrapper], .product-single__media-slide';
    var thumbsSelector = sectionEl.getAttribute('data-thumbs-selector') || '[data-product-single-media-thumbs]';

    var template = sectionEl.querySelector('template[data-size-hint-template]');
    var dictEl = sectionEl.querySelector('[data-size-hint-dict]');
    var mapEl = sectionEl.querySelector('[data-size-hint-map]');

    if (!template) {
      if (debug) warn('[SizeHintOverlay]', 'missing template in section', sectionEl);
      return;
    }

    var mode = dictEl ? 'alt_token' : (mapEl ? 'filename_map' : 'none');
    if (mode === 'none') {
      if (debug) warn('[SizeHintOverlay]', 'missing dict/map in section', sectionEl);
      return;
    }

    var dict = null;
    var dictLangCanonical = null;
    var tokenRegex = null;
    var locale = normalizeLocale(sectionEl.getAttribute('data-locale'));
    var tokenPattern = sectionEl.getAttribute('data-token-pattern') || '(?:^|\\s)(-[a-z0-9]+-[a-z0-9]+)\\s*$';

    if (mode === 'alt_token') {
      dict = safeJsonParse(dictEl.textContent, null);
      if (!dict || typeof dict !== 'object') {
        if (debug) warn('[SizeHintOverlay]', 'failed parsing dict JSON', { dictEl: dictEl });
        return;
      }

      try {
        tokenRegex = new RegExp(tokenPattern, 'i');
      } catch (e) {
        if (debug) warn('[SizeHintOverlay]', 'invalid token regex', { tokenPattern: tokenPattern, error: e });
        return;
      }

      var dictLang =
        (dict && dict[locale.full]) ||
        (dict && dict[locale.base]) ||
        (dict && dict.en) ||
        (dict && dict['en-us']) ||
        (dict && dict['en-gb']) ||
        null;

      if (!dictLang || typeof dictLang !== 'object') {
        if (debug) warn('[SizeHintOverlay]', 'missing language in dict; add a top-level key for the active language', { locale: locale, available: Object.keys(dict || {}) });
        dictLang = {};
      }

      dictLangCanonical = (function () {
        var canonical = {};
        Object.keys(dictLang || {}).forEach(function (key) {
          var k = (key || '').toString().trim().toLowerCase();
          if (k) canonical[k] = dictLang[key];
        });
        return canonical;
      })();
    }

    var sizeHintMap = null;
    var sizeHintMapCanonical = null;
    var sizeHintMapCanonicalNormalized = null;
    if (mode === 'filename_map') {
      sizeHintMap = safeJsonParse(mapEl.textContent, null);
      if (!sizeHintMap || typeof sizeHintMap !== 'object') {
        if (debug) warn('[SizeHintOverlay]', 'failed parsing map JSON', { mapEl: mapEl });
        return;
      }

      sizeHintMapCanonical = (function () {
        var canonical = {};
        Object.keys(sizeHintMap || {}).forEach(function (key) {
          var canonicalKey = canonicalizeFileName(key);
          if (canonicalKey) canonical[canonicalKey] = sizeHintMap[key];
        });
        return canonical;
      })();

      sizeHintMapCanonicalNormalized = (function () {
        var normalized = {};
        Object.keys(sizeHintMapCanonical || {}).forEach(function (key) {
          var normalizedKey = normalizeFileName(key);
          if (normalizedKey) normalized[normalizedKey] = sizeHintMapCanonical[key];
        });
        return normalized;
      })();
    }

    var source = sectionEl.getAttribute('data-source') || '';
    var sourceRequested = sectionEl.getAttribute('data-source-requested') || '';
    var metafield = sectionEl.getAttribute('data-metafield') || '';
    var metafieldResolved = sectionEl.getAttribute('data-metafield-resolved') === 'true';
    var keysCountAttr = sectionEl.getAttribute('data-keys-count');
    var keysCountFromLiquid = keysCountAttr ? parseInt(keysCountAttr, 10) : null;

    if (debug) {
      log('[SizeHintOverlay]', 'init', {
        gallerySelector: gallerySelector,
        slideSelector: slideSelector,
        thumbsSelector: thumbsSelector,
        mode: mode,
        locale: locale,
        tokenPattern: tokenPattern,
        source: source,
        sourceRequested: sourceRequested,
        metafield: metafield,
        metafieldResolved: metafieldResolved,
        keysFromLiquid: keysCountFromLiquid,
        keys: mode === 'filename_map' ? Object.keys(sizeHintMapCanonical || {}).slice(0, 20) : Object.keys(dictLangCanonical || {}).slice(0, 20),
        totalKeys: mode === 'filename_map' ? Object.keys(sizeHintMapCanonical || {}).length : Object.keys(dictLangCanonical || {}).length,
      });

    if (debug && sourceRequested === 'product_metafield' && source !== 'product_metafield') {
      warn('[SizeHintOverlay]', 'fell back to shop_global; check section setting product_metafield (namespace.key) and that the metafield has values for this product', {
        source: source,
        sourceRequested: sourceRequested,
        metafield: metafield,
        metafieldResolved: metafieldResolved
      });
    }
    }

    var tooltipIndex = 0;
    var debugSeen = {};
    var lastScanLogAt = 0;

    var applyToGallery = function (galleryEl, reason) {
      if (!galleryEl) return;

      var slides = galleryEl.querySelectorAll(slideSelector);
      if (debug) {
        var now = Date.now();
        if (reason !== 'mutation' || now - lastScanLogAt > 1000) {
          lastScanLogAt = now;
          log('[SizeHintOverlay]', 'scan gallery', { slides: slides.length, gallery: galleryEl, reason: reason || 'manual' });
        }
      }

      slides.forEach(function (slide) {
        if (isInside(slide, thumbsSelector)) return;
        if (slide.querySelector('[data-size-hint]')) return;

        var img = slide.querySelector('img');
        if (!img) return;

        var text = '';
        var debugPayload = null;

        if (mode === 'alt_token') {
          var altRaw = (img.getAttribute && img.getAttribute('alt')) || img.alt || '';
          var alt = normalizeAltForToken(altRaw);
          var match = alt && tokenRegex && alt.match(tokenRegex);
          var token = match && match[1] ? String(match[1]).trim().toLowerCase() : '';
          if (!token) {
            var fallbackMatch = alt && alt.match(/(?:^|\s)(-[a-z0-9]+-[a-z0-9]+)\s*$/i);
            token = fallbackMatch && fallbackMatch[1] ? String(fallbackMatch[1]).trim().toLowerCase() : '';
          }
          if (!token) {
            if (debug && altRaw && !debugSeen[altRaw]) {
              debugSeen[altRaw] = true;
              log('[SizeHintOverlay]', 'no token in alt', {
                alt: altRaw,
                normalizedAlt: alt !== altRaw ? alt : undefined,
                tokenPattern: tokenPattern,
                tail: debugTailCharCodes(altRaw, 18),
              });
            }
            return;
          }

          text = (dictLangCanonical && dictLangCanonical[token]) || '';
          if (debug && !debugSeen[token]) {
            debugSeen[token] = true;
            log('[SizeHintOverlay]', 'alt token', { token: token, hit: !!text, alt: alt });
          }
        } else {
          var url = img && (img.currentSrc || img.src);
          var rawFileName = getFileNameFromUrl(url);
          var fileName = canonicalizeFileName(rawFileName);
          if (!fileName) return;

          var normalized = normalizeFileName(fileName);
          debugPayload = { fileName: fileName, normalized: normalized };

          if (debug && !debugSeen[fileName]) {
            debugSeen[fileName] = true;
            log('[SizeHintOverlay]', 'slide image', {
              rawFileName: rawFileName,
              fileName: fileName,
              normalized: normalized,
              directHit: !!(sizeHintMapCanonical && sizeHintMapCanonical[fileName]),
              normalizedHit: !!(sizeHintMapCanonicalNormalized && sizeHintMapCanonicalNormalized[normalized]),
            });
          }

          text =
            (sizeHintMapCanonical && sizeHintMapCanonical[fileName]) ||
            (sizeHintMapCanonicalNormalized && sizeHintMapCanonicalNormalized[normalized]);
        }
        if (!text) return;

        tooltipIndex += 1;

        var fragment = template.content.cloneNode(true);
        var badge = fragment.querySelector('[data-size-hint-trigger]');
        var tooltip = fragment.querySelector('[data-size-hint-tooltip]');
        if (!badge || !tooltip) return;

        var tooltipId = 'SizeHintTooltip--' + tooltipIndex;
        tooltip.id = tooltipId;
        tooltip.textContent = text;
        badge.setAttribute('aria-describedby', tooltipId);
        badge.setAttribute('aria-label', text);

        slide.style.position = slide.style.position || 'relative';
        slide.appendChild(fragment);

        if (debug) log('[SizeHintOverlay]', 'matched', { mode: mode, meta: debugPayload, text: text });
      });
    };

    var setOpen = function (hintEl, open) {
      if (!hintEl) return;
      var isOpen = !!open;
      hintEl.setAttribute('data-open', isOpen ? 'true' : 'false');
      var button = hintEl.querySelector('[data-size-hint-trigger]');
      if (button) button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    var closeAll = function (exceptEl) {
      var openEls = document.querySelectorAll('[data-size-hint][data-open="true"]');
      openEls.forEach(function (el) {
        if (exceptEl && el === exceptEl) return;
        setOpen(el, false);
      });
    };

    var applyAll = function (reason) {
      var galleries = document.querySelectorAll(gallerySelector);
      galleries.forEach(function (g) { applyToGallery(g, reason); });
    };

    var scheduled = false;
    var scheduleApplyAll = function (reason) {
      if (scheduled) return;
      scheduled = true;
      var cb = function () {
        scheduled = false;
        applyAll(reason);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(cb);
      } else {
        window.setTimeout(cb, 16);
      }
    };

    applyAll('init');

    document.addEventListener('shopify:section:load', function () {
      applyAll('shopify:section:load');
    });

    document.addEventListener('click', function (event) {
      var target = event && event.target;
      if (!target) return;

      var trigger = target.closest && target.closest('[data-size-hint-trigger]');
      if (!trigger) {
        closeAll();
        return;
      }

      var hintEl = trigger.closest && trigger.closest('[data-size-hint]');
      if (!hintEl) return;

      event.preventDefault();
      event.stopPropagation();

      var isOpen = hintEl.getAttribute('data-open') === 'true';
      closeAll(hintEl);
      setOpen(hintEl, !isOpen);
    });

    document.addEventListener('keydown', function (event) {
      if (!event) return;
      if (event.key !== 'Escape') return;
      closeAll();
    });

    var mutationTouchesGallery = function (mutation) {
      if (!mutation) return false;
      var nodes = [];
      if (mutation.addedNodes && mutation.addedNodes.length) nodes = nodes.concat([].slice.call(mutation.addedNodes));
      if (mutation.removedNodes && mutation.removedNodes.length) nodes = nodes.concat([].slice.call(mutation.removedNodes));
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!n || n.nodeType !== 1) continue;
        if (n.matches && (n.matches(gallerySelector) || n.matches(slideSelector) || n.matches(thumbsSelector))) return true;
        if (n.querySelector && (n.querySelector(gallerySelector) || n.querySelector(slideSelector))) return true;
      }
      return false;
    };

    var observer = new MutationObserver(function (mutations) {
      if (!mutations || !mutations.length) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutationTouchesGallery(mutations[i])) {
          scheduleApplyAll('mutation');
          return;
        }
      }
    });

    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 12000);
  };

  var init = function () {
    var sections = document.querySelectorAll('[data-size-hint-overlay]');
    if (!sections.length) return;
    sections.forEach(initForSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
